__turbopack_context__.v({
  "container": "PrivateScheduleHint-module-scss-module__vpSzaq__container",
});
